import React, { useState } from "react";
import { Box, Card, makeStyles, Typography } from "@material-ui/core";
import { ToggleButton } from "@material-ui/lab";

import useMemberBadges from "../../../../hooks/useMemberBadges";
import useStatMembers from "../../../../hooks/useStatMembers";
import { useTranslate } from "react-admin";
import moment from "moment";
const useStyles = makeStyles((theme) => ({
  container: {
    width: 90,
    height: 90,
    borderRadius: "50%",
    backgroundColor: theme.lightGray,
    display: "grid",
    justifyContent: "center",
    border: "4px solid #EBEBEB",
    marginTop: 8,
  },
  rightToggleButton: {
    width: "100%",
    height: 38,
    borderTopRightRadius: 8,
    borderTopLeftRadius: 0,
    borderBottomRightRadius: 0,
    borderBottomLeftRadius: 0,
    overflow: "hidden",
    "&$selected": {
      color: theme.white,
      backgroundColor: theme.orange + "!important",
    },
  },
  leftToggleButton: {
    width: "100%",
    height: 38,
    borderTopLeftRadius: 8,
    borderBottomRightRadius: 0,
    borderBottomLeftRadius: 0,
    borderTopRightRadius: 0,
    overflow: "hidden",
    "&$selected": {
      color: theme.white,
      backgroundColor: theme.orange + "!important",
    },
  },
  card: {
    height: 190,
    width: 357,
    boxShadow: "0px 10px 0px -7px rgba(0,0,0,0)",
    marginTop: 6,
    borderRadius: 8,
  },
  textStyle: {
    fontSize: 20,
    fontWeight: "bold",
    margin: "auto",
  },
  textHeaderStyle: {
    fontSize: "20px",
    fontWeight: "bold",
    color: theme.blue,
  },
  selected: {},
}));
function StatisticComponent({ periodType, fromDate, toDate }) {
  const classes = useStyles();
  const [toggleButtonValue, setToggleButtonValue] = useState("BigSpender");
  const translate = useTranslate();
  const {
    badges,
    loading: badgesLoading,
    error: badgesError,
  } = useMemberBadges();
  const {
    members,
    loading: membersLoading,
    error: membersError,
  } = useStatMembers(periodType, fromDate, toDate);

  const {
    members: allMembers,
    loading: allMembersLoading,
    error: allMembersError,
  } = useStatMembers("All", "2020-01-01", moment().format("YYYY-MM-DD"));
  let customersBigspender = 0;
  let transactionBigspender = 0;
  let revenueBigspender = 0;

  let customersFrequency = 0;
  let transactionFrequency = 0;
  let revenueFrequency = 0;
  if (badgesLoading) return null;
  if (badgesError) return null;

  if (membersLoading || allMembersLoading) return null;
  if (membersError || allMembersError) return null;

  const memberswithLTV = members?.map((m) => {
    const found = allMembers?.find((a) => a.member_id === m.member_id);
    if (found) {
      return {
        ...m,
        ltv: found.payment.total_revenue,
        lifetime_transactions: found.payment.total_transaction,
      };
    } else return { ...m, ltv: 0, lifetime_transactions: 0 };
  });

  memberswithLTV?.forEach((element) => {
    if (
      element.lifetime_transactions >= badges[0].conditions[0].value &&
      element.payment?.total_transaction
    ) {
      customersFrequency++;
      transactionFrequency += element.payment.total_transaction;
      revenueFrequency += element.payment.total_revenue;
    }
    if (
      element.ltv >= badges[1].conditions[0].value &&
      element.payment?.total_transaction
    ) {
      customersBigspender++;
      transactionBigspender += element.payment.total_transaction;
      revenueBigspender += element.payment.total_revenue;
    }
  });

  let bigSpenders = [
    {
      name: translate("ra.text.bi.customer"),
      data: customersBigspender,
    },
    {
      name: translate("ra.text.bi.memberStatistic.transactions"),
      data: transactionBigspender,
    },
    {
      name: translate("ra.text.bi.memberStatistic.revenueTHB"),
      data: revenueBigspender,
    },
  ];
  let frequencyDatas = [
    {
      name: translate("ra.text.bi.customer"),
      data: customersFrequency,
    },
    {
      name: translate("ra.text.bi.memberStatistic.transactions"),
      data: transactionFrequency,
    },
    {
      name: translate("ra.text.bi.memberStatistic.revenueTHB"),
      data: revenueFrequency,
    },
  ];

  const handleToggleButton = (newValue) => {
    if (toggleButtonValue === newValue) {
      setToggleButtonValue(toggleButtonValue);
    } else {
      setToggleButtonValue(newValue);
    }
  };

  return (
    <Box>
      <Typography className={classes.textHeaderStyle}>
        {translate("ra.text.bi.memberStatistic.statistic")}{" "}
      </Typography>
      <Card className={classes.card}>
        <Box width="100%" display="flex">
          <ToggleButton
            value="BigSpender"
            onClick={(_, newValue) => {
              handleToggleButton(newValue);
            }}
            selected={toggleButtonValue === "BigSpender"}
            classes={{
              root: classes.leftToggleButton,
              selected: classes.selected,
            }}
          >
            {translate("ra.text.bi.memberStatistic.bigSpender")}
          </ToggleButton>
          <ToggleButton
            value="Frequency"
            onClick={(_, newValue) => {
              handleToggleButton(newValue);
            }}
            selected={toggleButtonValue === "Frequency"}
            classes={{
              root: classes.rightToggleButton,
              selected: classes.selected,
            }}
          >
            {translate("ra.text.bi.memberStatistic.frequency")}
          </ToggleButton>
        </Box>
        {toggleButtonValue === "BigSpender" ? (
          <Box display="flex" justifyContent="space-evenly">
            {bigSpenders.map((bigSpender, i) => (
              <Box key={i}>
                <Typography align="center" style={{ marginTop: 11 }}>
                  {bigSpender.name}
                </Typography>
                <Box className={classes.container}>
                  <Typography align="center" className={classes.textStyle}>
                    {bigSpender.data.toLocaleString()}
                  </Typography>
                </Box>
              </Box>
            ))}
          </Box>
        ) : (
          <Box display="flex" justifyContent="space-evenly">
            {frequencyDatas.map((frequency, i) => (
              <Box>
                <Typography align="center" style={{ marginTop: 11 }}>
                  {frequency.name}
                </Typography>
                <Box className={classes.container}>
                  <Typography align="center" className={classes.textStyle}>
                    {frequency.data.toLocaleString()}
                  </Typography>
                </Box>
              </Box>
            ))}
          </Box>
        )}
      </Card>
    </Box>
  );
}

export default StatisticComponent;
